import { DASHBOARD_ERRORS } from "../../common/constants/dashboardModule/dashboardConstants.js";
import { TRANSFERS_ERRORS } from "../../common/constants/dashboardModule/transferConstants.js";
import { DASHBOARD_URLS } from "../apiConfig.js";
import apiClient from "../apiInstance.js";

export const fetchOptinData = async ({startDate, endDate, optinType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_OPTIN, {
            startDate,
            endDate,
            optinType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_OPTIN_ERROR, error);
        throw error;
    }
};

export const fetchLanguageData = async ({startDate, endDate, languageType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_LANGUAGE, {
            startDate,
            endDate,
            languageType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_LANGUAGE_ERROR, error);
        throw error;
    }
};

export const fetchPromisesData = async ({startDate, endDate, promisesType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_PROMISES, {
            startDate,
            endDate,
            promisesType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_LANGUAGE_ERROR, error);
        throw error;
    }
};

export const fetchConversationTimeData = async ({startDate, endDate, conversationTimeType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CONVERSATION_TIME, {
            startDate,
            endDate,
            conversationTimeType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_CONVERSATION_TIME_ERROR, error);
        throw error;
    }
};

export const fetchDPDData = async ({startDate, endDate, dpdType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_DPD, {
            startDate,
            endDate,
            dpdType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_DPD_ERROR, error);
        throw error;
    }
};

export const fetchTransfersText = async () => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_TRANSFERS_TEXT);
        return response.data;
    } catch (error) {
        console.error(TRANSFERS_ERRORS.FETCH_TEXTS_ERROR, error);
        throw error;
    }
};

export const fetchTransfersEmail = async () => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_TRANSFERS_EMAIL);
        return response.data;
    } catch (error) {
        console.error(TRANSFERS_ERRORS.FETCH_EMAILS_ERROR, error);
        throw error;
    }
};



export const fetchActivityData = async ({startDate, endDate, activityType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_ACTIVITY, {
            startDate,
            endDate,
            activityType
        });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_ACTIVITY_ERROR, error);
        throw error;
    }
};

export const fetchComplianceData = async ({startDate, endDate, complianceType}) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_COMPLIANCE_STATS, { startDate, endDate, complianceType });
        return response.data;
    } catch (error) {
        console.error(DASHBOARD_ERRORS.FETCH_COMPLIANCE_STATS_ERROR, error);
        throw error;
    }
};



export const fetchCustomerTextChart = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_TEXT_CHART, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer text chart", error);
        throw error;
    }
};

export const fetchCustomerEmailChart = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_EMAIL_CHART, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer email chart", error);
        throw error;
    }
};


export const fetchCustomerDataUpload = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_DATAUPLOAD, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer data upload", error);
        throw error;
    }
};

export const fetchCustomerDataUploadChart = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_DATAUPLOAD_CHART, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer data upload chart", error);
        throw error;
    }
};

export const fetchCustomerCallChart = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_CALL_CHART, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer call chart", error);
        throw error;
    }
};

export const fetchCustomerChatChart = async (customerguid) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_CUSTOMER_CHAT_CHART, { customerguid });
        return response.data;
    } catch (error) {
        console.error("Error fetching customer chat chart", error);
        throw error;
    }
};

export const fetchLanguageConversations = async ({ language, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_LANGUAGE_CONVERSATIONS, {
        language, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching language conversations", error);
      throw error;
    }
  };
  
  export const fetchOptoutConversations = async ({ customerId, startDate, endDate, optinType }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_OPTOUT_CONVERSATIONS, {
        customerId, startDate, endDate, optinType,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching optout conversations", error);
      throw error;
    }
  };
  
  export const fetchConversationTimeConversations = async ({ startDate, endDate, conversationTimeType }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_CONVERSATION_TIME_CONVERSATIONS, {
        startDate, endDate, conversationTimeType,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching conversation-time conversations", error);
      throw error;
    }
  };

  export const fetchDPDConversations = async ({ startDate, endDate, dpdType, bucket }) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_DPD_CONVERSATIONS, {
            startDate, endDate, dpdType, bucket,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching DPD conversations", error);
        throw error;
    }
};

export const fetchTransfersConversations = async ({ language, startDate, endDate, channeltype }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_TRANSFERS_CONVERSATIONS, {
        language, startDate, endDate, channeltype,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching transfers conversations", error);
      throw error;
    }
};

export const fetchHiResponses = async ({ date }) => {
    try {
        const response = await apiClient.post(DASHBOARD_URLS.GET_HI_RESPONSES, { date });
        return response.data;
    } catch (error) {
        console.error("Error fetching Hi responses", error);
        throw error;
    }
};

export const fetchEventActivity = async ({ startDate, endDate, dpdMin, dpdMax }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_EVENT_ACTIVITY, {
        startDate,
        endDate,
        dpdMin,
        dpdMax,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching event activity data", error);
      throw error;
    }
  };

  export const fetchDpdDayActivity = async ({ startDate, endDate, dpdMin, dpdMax, channel }) => {
    try {
      const response = await apiClient.post(DASHBOARD_URLS.GET_DPD_DAY_ACTIVITY, {
        startDate,
        endDate,
        dpdMin,
        dpdMax,
        channel, // optional; server defaults to 'texts'
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching DPD day activity data", error);
      throw error;
    }
  };